import { memo } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/shared/components/ui/dialog";
import { Button } from "@/shared/components/ui/button";
import { AlertTriangle } from "lucide-react";
import type { RentalResponseDTO } from "@/shared/types/rental.types";

interface RentalDeleteDialogProps {
  open: boolean;
  rental: RentalResponseDTO | null;
  loading: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const RentalDeleteDialog = memo(function RentalDeleteDialog({
  open,
  rental,
  loading,
  onConfirm,
  onClose,
}: RentalDeleteDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Cancelar aluguel</DialogTitle>
          <DialogDescription>
            Tem certeza que deseja cancelar este aluguel?
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <div className="p-4 bg-destructive/10 rounded-md border border-destructive/20">
            <div className="flex items-start gap-3">
              <AlertTriangle className="w-5 h-5 text-destructive shrink-0 mt-0.5" />
              <div>
                <p className="font-semibold">{rental?.contractNumber}</p>
                <p className="text-sm text-muted-foreground">
                  Cliente: {rental?.clientName}
                </p>
                <p className="text-sm text-destructive mt-2">
                  As peças serão liberadas e as notas fiscais pendentes serão
                  canceladas. Esta ação não pode ser desfeita!
                </p>
              </div>
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={loading}>
            Cancelar
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={loading}>
            {loading ? "Cancelando..." : "Cancelar aluguel"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
});
